import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "../i18n/langs";
Vue.use(VueI18n);

export function publicList() {
  const i18n = new VueI18n({
    locale: window.localStorage.getItem("lang"),
    messages,
    silentTranslationWarn: true,
  });

  const dropdownList = [
    {
      id: "a",
      icon: "el-icon-info",
      title: i18n.t("message.title.aboutUs"),
      link: "http://www.jiexininfo.com/",
    },
    {
      id: "d",
      icon: "el-icon-data-line",
      title: i18n.t("message.title.studyOnline"),
      link: "https://live.swift-plm.com/video/index.html",
    },
    {
      id: "e",
      icon: "el-icon-phone-outline",
      title: i18n.t("message.title.serviceOnline"),
      link: "http://support.jiexininfo.com:9080/",
    },
    {
      id: "g",
      icon: "el-icon-view",
      title: i18n.t("message.title.viewTool"),
      link: "https://live.swift-plm.com/tools/ViewTool.zip",
    },
    { id: "b", icon: "el-icon-edit", title: i18n.t("message.title.changePW") },
    {
      id: "f",
      icon: "el-icon-s-tools",
      title: i18n.t("message.title.userSetting"),
    },
    {
      id: "c",
      icon: "el-icon-switch-button",
      title: i18n.t("message.title.logout"),
    },
  ];

  const navList = [
    {
      icon: "iconfont icon-yibiao",
      // name: i18n.t("message.title.myDashboard"),
      title: i18n.t("message.title.myDashboard"),
      name: i18n.t("message.title.myDashboard"),
      path: "/echarts",
      content: "echarts",
      children: [],
      order: 1,
    },
    {
      icon: "iconfont icon-liucheng11",
      // name: i18n.t("message.title.myProcess"),
      title: i18n.t("message.title.myProcess"),
      name: i18n.t("message.title.myProcess"),
      path: "/welcome",
      content: "welcome",
      children: [],
      order: 1,
    },
    {
      icon: "iconfont icon-base_itemxiangmuguanli",
      // name: i18n.t("message.title.myProject"),
      title: i18n.t("message.title.myProject"),
      name: i18n.t("message.title.myProject"),
      path: "/myProject",
      content: "myProject",
      children: [],
      order: 2,
    },
    {
      icon: "iconfont icon-renwu1",
      // name: i18n.t("message.title.myAgent"),
      title: i18n.t("message.title.myAgent"),
      name: i18n.t("message.title.myAgent"),
      path: "/myAgent",
      content: "myAgent",
      children: [],
      order: 2,
    },
    // {
    //   icon: "iconfont icon-renwu1",
    //   name: '实验室管理',
    //   title: '实验室管理',
    //   path: "/abc",
    //   content: "abc",
    //   show: true,
    //   children: []
    // },
    // {
    //   icon: "el-icon-eleme",
    //   name: "调试",
    //   title: "调试",
    //   path: "/test",
    //   order:2
    //   // content: "/calendar",
    // },
    // {
    //   icon: "el-icon-eleme",
    //   name: "调试2",
    //   title: "调试2",
    //   path: "/test",
    //   order: 1,
    //   // content: "/calendar",
    // },
    {
      icon: "el-icon-files",
      name: i18n.t("message.title.componentLibrary"),
      title: i18n.t("message.title.componentLibrary"),
      path: "/componentLibrary",
      order: 1,
      // content: "/calendar",
    },
    {
      icon: "el-icon-folder-opened",
      name: i18n.t("message.title.folder"),
      title: i18n.t("message.title.folder"),
      // path: "/test",
      path: "/folderList",
      order: 1,
      type: "folder",
      // content: "/calendar",
    },
    // {
    // 	icon:'iconfont icon-renwu1',
    // 	name: "我的任务",
    //   title: "我的任务",
    //   path: "/test",
    // },
    // {
    // 	icon:'iconfont icon-wendang',
    // 	name: "我的文档",
    // },
    // {
    // 	icon:'iconfont icon-taolun',
    // 	name: "我的讨论",
    // title: "我的文件",
    // path: "/folders",
    // content: "/folders",
    // }
  ];

  const Global = {
    input_width: {
      width: "76%",
    },
    input_width_small: {
      width: "45%",
    },
    right_lists_0: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
    ],
    right_lists_1: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.pageOne"),
        id: 1,
      },
      {
        name: i18n.t("message.list.pageTwo"),
        id: 2,
      },
    ],
    right_lists_1_2: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.pageOne"),
        id: 1,
      },
      {
        name: i18n.t("message.list.pageTwo"),
        id: 2,
      },
      {
        name: i18n.t("message.list.pageThree"),
        id: 3,
      },
    ],
    right_lists_2: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.pendingChange"),
        id: 6,
      },
      {
        name: i18n.t("message.list.changeHistory"),
        id: 7,
      },
    ],
    right_lists_3: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: "BOM",
        id: 4,
      },
    ],
    right_lists_4: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.manufacturer"),
        id: 16,
      },
    ],
    right_lists_5: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.attachment"),
        id: 201,
      },
    ],
    right_lists_6: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.whereUsed"),
        id: 8,
      },
      {
        name: i18n.t("message.list.pendingChangeWhereUsed"),
        id: 9,
      },
    ],
    right_lists_7: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.relationship"),
        id: 200,
      },
    ],
    right_lists_8: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 10,
      },
    ],
    right_lists_9: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.affectedObjects"),
        id: 5,
      },
    ],
    right_lists_10: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.preferences"),
        id: 91,
      },
    ],
    right_lists_11: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.userGroup"),
        id: 95,
      },
    ],
    right_lists_12: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.user"),
        id: 92,
      },
    ],
    right_lists_13: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.whereUsed"),
        id: 17,
      },
    ],
    right_lists_14: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 15,
      },
    ],
    right_lists_15: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 13,
      },
    ],
    right_lists_16: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 14,
      },
    ],
    right_lists_17: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 94,
      },
    ],
    right_lists_18: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 93,
      },
    ],
    right_lists_19: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.whereUsed"),
        id: 18,
      },
    ],
    right_lists_20: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 59,
      },
    ],
    right_lists_21: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.deliverables"),
        id: 200,
      },
    ],
    right_lists_22: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.team"),
        id: 55,
      },
    ],
    right_lists_23: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.schedule"),
        id: 54,
      },
    ],
    right_lists_24: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.scheduleComments"),
        id: 56,
      },
    ],
    right_lists_25: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 49,
      },
    ],
    right_lists_26: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.questionObject"),
        id: 41,
      },
    ],
    right_lists_27: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.associateTheSameForm"),
        id: 42,
      },
    ],
    right_lists_28: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.itemQuality"),
        id: 60,
      },
    ],
    right_lists_29: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.pendingChange"),
        id: 21,
      },
      {
        name: i18n.t("message.list.changeHistory"),
        id: 22,
      },
    ],
    right_lists_30: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.BOM"),
        id: 23,
      },
    ],
    right_lists_31: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.relatedItem"),
        id: 24,
      },
    ],
    right_lists_32: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.relatedResource"),
        id: 25,
      },
    ],
    right_lists_33: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.whereUsed"),
        id: 26,
      },
      {
        name: i18n.t("message.list.pendingChangeWhereUsed"),
        id: 27,
      },
    ],
    right_lists_34: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 29,
      },
    ],
    right_lists_35: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.owningTechnology"),
        id: 31,
      },
    ],
    right_lists_36: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.owningGroup"),
        id: 32,
      },
    ],
    right_lists_37: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.owningResource"),
        id: 33,
      },
    ],
    right_lists_38: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.historyRecord"),
        id: 39,
      },
    ],
    right_lists_39: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.itemRelatedTechnology"),
        id: 61,
      },
    ],
    right_lists_40: [
      {
        name: i18n.t("message.list.baseInfo"),
      },
      {
        name: i18n.t("message.list.itemAttachment"),
        id: 201,
      },
    ],
  };

  const settingList = [
    {
      type: "a",
      icon: "el-icon-info",
      name: i18n.t("message.title.aboutUs"),
      link: "http://www.jiexininfo.com/",
    },
    {
      type: "d",
      icon: "el-icon-data-line",
      name: i18n.t("message.title.studyOnline"),
      link: "https://live.swift-plm.com/video/index.html",
    },
    {
      type: "e",
      icon: "el-icon-phone-outline",
      name: i18n.t("message.title.serviceOnline"),
      link: "http://support.jiexininfo.com:9080/",
    },
    {
      type: "g",
      icon: "el-icon-view",
      name: i18n.t("message.title.viewTool"),
      link: "https://live.swift-plm.com/tools/ViewTool.zip",
    },
    { type: "b", icon: "el-icon-edit", name: i18n.t("message.title.changePW") },
    {
      type: "f",
      icon: "el-icon-s-tools",
      name: i18n.t("message.title.userSetting"),
    },
    {
      type: "c",
      icon: "el-icon-switch-button",
      name: i18n.t("message.title.logout"),
    },
  ];
  const processTabList = [
    {
      name: i18n.t("message.title.myPriority"),
    },
    {
      name: i18n.t("message.title.mySubmit"),
    },
    {
      name: i18n.t("message.title.myTracing"),
    },
    {
      name: i18n.t("message.title.myNotice"),
    },
  ];
  const statusTypeList = [
    {
      label: i18n.t("message.workflowType.Pending"),
      value: 0,
    },
    {
      label: i18n.t("message.workflowType.Submit"),
      value: 1,
    },
    {
      label: i18n.t("message.workflowType.Review"),
      value: 2,
    },
    {
      label: i18n.t("message.workflowType.Released"),
      value: 3,
    },
    {
      label: i18n.t("message.workflowType.Complete"),
      value: 4,
    },
    {
      label: i18n.t("message.workflowType.Cancel"),
      value: 5,
    },
    {
      label: i18n.t("message.workflowType.Hold"),
      value: 6,
    },
  ];

  return {
    dropdownList,
    navList,
    Global,
    settingList,
    processTabList,
    statusTypeList,
  };
}

const urlList = [
  {
    id: 101,
    url: "/item",
  },
  {
    id: 104,
    url: "/changePage",
  },
  {
    id: 105,
    url: "/manufactPage",
  },
  {
    id: 106,
    url: "/manufactPartPage",
  },
  {
    id: 901,
    url: "/UserItem",
  },
  {
    id: 902,
    url: "/UserGroupItem",
  },
  {
    id: 301,
    url: "/project",
  },
  {
    id: 401,
    url: "/quality",
  },
  {
    id: 501,
    url: "/technology",
  },
  {
    id: 502,
    url: "/resource",
  },
];

export const projectTabList = [
  { id: 1030101, path: "./projectTitle" },
  { id: 1030102, path: "./projectSchedule" },
  { id: 1030103, path: "./projectTeam" },
  { id: 1030104, path: "./projectScheduleComments" },
  { id: 1030105, path: "./ProjectAttachment" },
  { id: 1030106, path: "./projectDeliverable" },
  { id: 1030107, path: "./projectWorkflowInformation" },
  { id: 1030109, path: "./projectHistory" },
];

// export const baseInfo = [
//   { id: 101, searchUrl: "/search/advanced/searchItemAndExportExcel" },
//   { id: 104, searchUrl: "/search/advanced/searchChangeAndExportExcel" },
//   { id: 105, searchUrl: "/search/advanced/searchManufacturerAndExportExcel" },
//   { id: 301, searchUrl: "/ppm/projectStatus//searchProjectAndExportExcel" },
// ];

export const baseInfo = [
  // { id: 101, searchUrl: "/search/advanced/searchItemAndExportExcel" },
  // { id: 104, searchUrl: "/search/advanced/searchChangeAndExportExcel" },
  // { id: 105, searchUrl: "/search/advanced/searchManufacturerAndExportExcel" },
  // { id: 301, searchUrl: "/ppm/projectStatus//searchProjectAndExportExcel" },
  {
    id: 101,
    searchUrl: "/search/advanced/searchItemAndExportExcel",
    loadTable: "/pmdm/items/loadTable",
    saveTable: "/pmdm/items/updateItemP1P2P3",
  },
  {
    id: 104,
    searchUrl: "/search/advanced/searchChangeAndExportExcel",
    loadTable: "/pmdm/changes/loadTable",
    saveTable: "/pmdm/changes/updateChangeP1P2P3",
  },
  {
    id: 105,
    searchUrl: "/search/advanced/searchManufacturerAndExportExcel",
    loadTable: "/pmdm/manufacturers/loadTable",
    saveTable: "/pmdm/manufacturers/updateManufacturerP1P2P3",
  },
  {
    id: 106,
    searchUrl: "",
    loadTable: "/pmdm/manufacturerPart/loadTable",
    saveTable: "/pmdm/manufacturerPart/updateManufacturerPartP1P2P3",
  },
  {
    id: 301,
    searchUrl: "/ppm/projectStatus/searchProjectAndExportExcel",
    loadTable: "",
    saveTable: "",
  },
  {
    id: 401,
    searchUrl: "",
    loadTable: "/pqm/quality/loadTable",
    saveTable: "/pqm/quality/updateQualityP1P2P3",
  },
  {
    id: 901,
    loadTable: "/pmdm/admin/user/loadTable",
    saveTable: "/pmdm/admin/user/update",
  },
  {
    id: 902,
    loadTable: "/pmdm/admin/userGroup/loadTable",
    saveTable: "/pmdm/admin/userGroup/update",
  },
  {
    id: 501,
    searchUrl: "",
    loadTable: "/pmdm/technology/loadTable",
    saveTable: "/pmdm/technology/updateTechnologyP1P2P3",
  },
  {
    id: 502,
    searchUrl: "",
    loadTable: "/pmdm/resource/loadTable",
    saveTable: "/pmdm/resource/updateResourceP1P2P3",
  },
];

export const itemTabList = [
  {
    //公用tabid
    id: 1010101,
    classId: 101,
    name: "详细信息",
    path: "/titleBlock",
  },
  {
    id: 1010102,
    classId: 101,
    name: "变更",
    path: "/itemChanges",
  },
  {
    id: 1010103,
    classId: 101,
    name: "BOM",
    path: "/BOM",
    tableId: 4,
  },
  {
    id: 1010109,
    classId: 101,
    name: "BOM1",
    path: "/BOM",
    tableId: 4000,
  },
  {
    id: 1010110,
    classId: 101,
    name: "BOM2",
    path: "/BOM",
    tableId: 4001,
  },
  {
    id: 1010111,
    classId: 101,
    name: "BOM3",
    path: "/BOM",
    tableId: 4002,
  },
  {
    id: 1010112,
    classId: 101,
    name: "BOM3",
    path: "/BOM",
    tableId: 4003,
  },
  {
    id: 1010113,
    classId: 101,
    name: "BOM3",
    path: "/BOM",
    tableId: 4004,
  },
  {
    id: 1010114,
    classId: 101,
    name: "BOM4",
    path: "/BOM",
    tableId: 4005,
  },
  {
    id: 1010115,
    classId: 101,
    name: "BOM5",
    path: "/BOM",
    tableId: 4006,
  },
  {
    id: 1010116,
    classId: 101,
    name: "BOM6",
    path: "/BOM",
    tableId: 4007,
  },
  {
    id: 1010117,
    classId: 101,
    name: "BOM7",
    path: "/BOM",
    tableId: 4008,
  },
  {
    id: 1010118,
    classId: 101,
    name: "BOM8",
    path: "/BOM",
    tableId: 4009,
  },

  {
    id: 1010104,
    classId: 101,
    name: "制造商",
    path: "/manufacturers",
  },

  {
    id: 1010105,
    classId: 101,
    name: "附件",
    path: "/itemAttachment",
  },
  {
    id: 1010106,
    classId: 101,
    name: "使用位置",
    path: "/itemWhereUsed",
  },
  {
    id: 1010107,
    classId: 101,
    name: "关联对象",
    path: "/itemRelationship",
  },
  {
    id: 1010108,
    classId: 101,
    name: "质量单",
    path: "/itemQualityPage",
  },
  {
    id: 1010119,
    classId: 101,
    name: "工艺信息",
    path: "/itemRelatedTechnology",
  },
  {
    id: 1010130,
    classId: 101,
    name: "历史记录",
    path: "/itemHistory",
  },
];

export const changeTabList = [
  { id: 1010401, path: "/changeTitleBlock" },
  { id: 1010402, path: "/changeAffectedItem" },
  { id: 1010403, path: "/changeWorkflow" },
  { id: 1010404, path: "/changeAttachment" },
  { id: 1010405, path: "/changeRelationship" },
  { id: 1010406, path: "/changeHistory" },
];

export const qualityTabList = [
  { id: 4040101, path: "/qualityTitleBlock" },
  { id: 4040103, path: "/qualityRelationItem" },
  { id: 4040105, path: "/qualityWorkflow" },
  { id: 4040107, path: "/qualityRelevance" },
  { id: 4040109, path: "/qualityAttachment" },
  { id: 4040111, path: "/qualityRelationship" },
  { id: 4040113, path: "/qualityHistory" },
];

export const technologyTabList = [
  { id: 1050101, path: "/technologyTitleBlock" },
  { id: 1050102, path: "/technologyChange" },
  { id: 1050103, path: "/technologyBOM" },
  { id: 1050104, path: "/technologyRelatedItem" },
  { id: 1050105, path: "/technologyRelatedResource" },
  { id: 1050106, path: "/technologyRelatedTechnology" },
  { id: 1050107, path: "/technologyAttachment" },
  { id: 1050118, path: "/technologyHistory" },
];

export const CappResourceTabList = [
  { id: 1050201, path: "/ResourceTitleBlock" }, //详细信息
  { id: 1050202, path: "/ResourceRelatedResource" }, //所属资源
  { id: 1050203, path: "/ResourceRelatedtechnology" }, //所属工艺路线
  { id: 1050204, path: "/ResourceAttachment" }, //附件
  { id: 1050215, path: "/ResourceHistory" }, //历史记录
];

export const manufacturerTabList = [
  { id: 1010501, path: "/ManuFactTitleBlock" },
  { id: 1010502, path: "/ManuFactAttachment" },
  { id: 1010503, path: "/ManuFactWhereUsed" },
  { id: 1010504, path: "/ManuFactRelationship" },
  { id: 1010505, path: "/ManuFactHistory" },
];

export const manufacturerPartTabList = [
  { id: 1010601, path: "/ManuFactPartTitleBlock" },
  { id: 1010602, path: "/ManuFactPartAttachment" },
  { id: 1010603, path: "/ManuFactPartWhereUsed" },
  { id: 1010604, path: "/ManuFactPartRelationship" },
  { id: 1010605, path: "/ManuFactPartHistory" },
];

export const userTabList = [
  { id: 1090101, path: "/UserInfo" },
  { id: 1090102, path: "/UserPreferences" },
  { id: 1090106, path: "/UserAuthorization" },
  { id: 1090107, path: "/UserGroup" },
  { id: 1090108, path: "/UserAttachment" },
  { id: 1090109, path: "/UserHistory" },
];

export const userGroupTabList = [
  {
    id: 1090201,
    classId: 902,
    name: "详细信息",
    path: "/UserGroupInfo",
  },
  {
    id: 1090202,
    classId: 902,
    name: "用户",
    path: "/UserGroupUsers",
  },
  {
    id: 1090203,
    classId: 902,
    name: "分配",
    path: "/UserGroupAssignment",
  },
  {
    id: 1090204,
    classId: 902,
    name: "关联对象",
    path: "/UserGroupRelationship",
  },
  {
    id: 1090205,
    classId: 902,
    name: "附件",
    path: "/UserGroupAttachment",
  },
  {
    id: 1090206,
    classId: 902,
    name: "历史记录",
    path: "/UserGroupHistory",
  },
];

export default {
  // dropdownList,
  // navList,
  // Global,
  // processTabList,
  projectTabList,
  itemTabList,
  changeTabList,
  manufacturerTabList,
  manufacturerPartTabList,
  userTabList,
  userGroupTabList,
  urlList,
  qualityTabList,
  technologyTabList,
  CappResourceTabList,
  // statusTypeList,
  // settingList,
};
